"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SortSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SortSVG = function SortSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M18.17 19.52a2 2 0 00-2.94 2.71l5.65 6.13a2 2 0 002.94 0l5.65-6.13a2 2 0 00-2.94-2.71l-2.19 2.37V5a2 2 0 00-4 0v16.88zM9.66 29a2 2 0 01-2-2V10.11l-2.19 2.37a2 2 0 01-2.94-2.71l5.65-6.13a2 2 0 012.94 0l5.65 6.13a2 2 0 01-2.94 2.71l-2.17-2.36V27a2 2 0 01-2 2z"
  }));
};
exports.SortSVG = SortSVG;
SortSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SortSVG);
exports.default = _default;